import styled from "styled-components";

export const AddInstrumentFormStyled = styled.div`
  border-radius: 0.5rem;
  padding: 30px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .title_wrap {
    .title {
      margin-bottom: 8px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .sub_title {
      margin-bottom: 28px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      white-space: pre-wrap;
    }
  }

  .input_wrap {
    margin-bottom: 27px;
    &.mb_12 {
      margin-bottom: 12px;
    }
    &.mb_44 {
      margin-bottom: 44px;
    }
  }
  .btn_row_wrap {
    margin-bottom: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 32px;
    .btn_wrap {
      width: 100%;
    }
  }
`;
